import { createRouter, createWebHistory } from 'vue-router'
import { isLoggedIn } from '@/utils/auth'
import MainLayout from '@/layouts/MainLayout.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Index.vue'),
    meta: {
      title: '登录',
      public: true
    }
  },
  {
    path: '/monitor/share',
    name: 'MonitorShare',
    component: () => import('@/views/Monitor/Index.vue'),
    meta: {
      title: '订单监控',
      public: true,
      share: true
    }
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/orders',
    children: [
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/Orders/Index.vue'),
        meta: { title: '订单管理' }
      },
      {
        path: 'drivers',
        name: 'Drivers',
        component: () => import('@/views/Drivers/Index.vue'),
        meta: { title: '司机管理' }
      },
      {
        path: 'vehicles',
        name: 'Vehicles',
        component: () => import('@/views/Vehicles/Index.vue'),
        meta: { title: '车辆管理' }
      },
      {
        path: 'monitor',
        name: 'Monitor',
        component: () => import('@/views/Monitor/Index.vue'),
        meta: { title: '订单监控' }
      },
      {
        path: 'reject-review',
        name: 'RejectReview',
        component: () => import('@/views/RejectReview/Index.vue'),
        meta: { title: '拒单审核' }
      },
      {
        path: 'contract-review',
        name: 'ContractReview',
        component: () => import('@/views/ContractReview/Index.vue'),
        meta: { title: '合同信息' }
      },
      {
        path: 'finance',
        name: 'Finance',
        component: () => import('@/views/Finance/Index.vue'),
        meta: { title: '财务统计' }
      },
      {
        path: 'service-scope',
        name: 'ServiceScope',
        component: () => import('@/views/ServiceScope/Index.vue'),
        meta: { title: '运营范围' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile/Index.vue'),
        meta: { title: '个人中心' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/orders'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - 装修垃圾清运调度端`
  }

  const loggedIn = isLoggedIn()

  if (to.path === '/login') {
    if (loggedIn) {
      next('/orders')
    } else {
      next()
    }
    return
  }

  if (!to.meta.public && !loggedIn) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }

  next()
})

// 开发环境热更新或 devServer 重启后，浏览器可能仍缓存旧的 app.js，导致懒加载 chunk 404
router.onError((error, to) => {
  const isChunkLoadError = /Loading chunk .* failed|ChunkLoadError/i.test(error?.message || '')
  if (!isChunkLoadError) {
    return
  }
  const retryKey = `chunk-retry:${to.fullPath}`
  if (sessionStorage.getItem(retryKey)) {
    sessionStorage.removeItem(retryKey)
    return
  }
  sessionStorage.setItem(retryKey, '1')
  window.location.assign(to.fullPath)
})

export default router
